import React from 'react';
import PropTypes from 'prop-types';

import Heading from 'components/heading';
import Image from 'components/image';
import Icon from 'components/icon';

const HousingProjectContactCardContent = ({ text, items }) => (
  <>
    {text && (
      <p className="housing-project-contact-card__description">{text}</p>
    )}

    {items?.length && (
      <ul
        id="housingProjectContactCardContent"
        className="housing-project-contact-card__items"
      >
        {items?.map(({ image, title, phone, email, logo }, index) => (
          <li
            // eslint-disable-next-line react/no-array-index-key
            key={`${title}-${index}`}
            className="housing-project-contact-card__item"
          >
            {image && (
              <div className="housing-project-contact-card__item-image">
                <Image theme={Image.themes.background} {...image} />
              </div>
            )}

            <div className="housing-project-contact-card__item-body">
              {title && (
                <Heading level={3} theme={Heading.themes.h4}>
                  {title}
                </Heading>
              )}
            </div>

            <div className="housing-project-contact-card__item-contacts">
              {phone && phone.text && (
                <a
                  href={phone.url}
                  className="housing-project-contact-card__item-contact"
                >
                  <div className="housing-project-contact-card__item-contact-icon-wrapper">
                    <Icon
                      name="phone"
                      className="housing-project-contact-card__item-contact-icon"
                      role="img"
                      aria-label="Telefonnummer"
                    />
                  </div>

                  <span className="housing-project-contact-card__item-contact-text-wrapper">
                    <span className="housing-project-contact-card__item-contact-text">
                      {phone.text}
                    </span>
                  </span>
                </a>
              )}
              {email && email.text && (
                <a
                  href={email.url}
                  className="housing-project-contact-card__item-contact"
                >
                  <div className="housing-project-contact-card__item-contact-icon-wrapper">
                    <Icon
                      name="mail"
                      className="housing-project-contact-card__item-contact-icon"
                      role="img"
                      aria-label="E‑postadresse"
                    />
                  </div>
                  <span className="housing-project-contact-card__item-contact-text-wrapper">
                    <span className="housing-project-contact-card__item-contact-text">
                      {email.text}
                    </span>
                  </span>
                </a>
              )}
            </div>

            {logo && (
              <div className="housing-project-contact-card__item-logo">
                <Image {...logo} isObjectFitContain />
              </div>
            )}
          </li>
        ))}
      </ul>
    )}
  </>
);

HousingProjectContactCardContent.propTypes = {
  text: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.exact({
      title: PropTypes.string,
      image: PropTypes.exact(Image.propTypes),
      phone: PropTypes.shape({ text: PropTypes.string, url: PropTypes.string }),
      email: PropTypes.shape({ text: PropTypes.string, url: PropTypes.string }),
      logo: PropTypes.exact(Image.propTypes)
    })
  )
};

export default HousingProjectContactCardContent;
